exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".about-us-text{\r\n    background-color: #fff;\r\n    top: -50px;\r\n    text-align: justify;\r\n    padding: 40px 30px 10px;\r\n}\r\n\r\n.about-us-text h5{\r\n    text-align: center !important;\r\n  \r\n}\r\n\r\n.lastChild{\r\n    margin-bottom: 3rem;\r\n}\r\n\r\n.project-vision{\r\n    font-size: 0.7rem;\r\n    text-decoration: underline;\r\n    margin-top: 40px;\r\n    margin-bottom: 30px;\r\n    font-style: italic;\r\n}\r\n\r\n.project-vision a {\r\n   color: #000 !important;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/about-us/about-us.component.css
// module id = ../../../../../src/app/about-us/about-us.component.css
// module chunks = main